@file:OptIn(ExperimentalWasmJsInterop::class)

package fr.arcplex.sooner

import fr.arcplex.sooner.infrastructure.PlatformIdentity

@JsFun("(key) => window.localStorage.getItem(key)")
external fun jsGetLocalStorageItem(key: String): String?

@JsFun("(key, value) => window.localStorage.setItem(key, value)")
external fun jsSetLocalStorageItem(key: String, value: String)

actual fun getLocalStorageItem(key: String): String? = jsGetLocalStorageItem(key)
actual fun setLocalStorageItem(key: String, value: String) = jsSetLocalStorageItem(key, value)

actual fun getWebIdentity(): PlatformIdentity = WebIdentity()
